<template>
  <div class="tab-container">
    <vue-dialog
      color="#00b5f0"
      v-if="show_dialog"
      :name="data_name"
      :left="data_left"
      :right="data_right"
      :title="data_title"
      :value="data_value"
      @dialog_end="dialogend"
    >
    </vue-dialog>
    <div class="location-indent">
      <div class="location-title">{{ loc_select_title }}</div>
      <div class="location-image-container">
        <img class="location-pin" src="../assets/images/location_big_yellow.svg" alt="" />
        <img class="location-globus" src="../assets/images/globus.png" alt="" />
      </div>
      <!-- <div class="location-row">
        <div class="left">
          <img src="../assets/images/country_logo.png" />
        </div>
        <div class="right">
          <select :value="loc_country.value" @change="valuechange('loc_country', $event.target.value)">
            <option :key="'country' + key" v-for="(value, key) in loc_country.data" :value="key">{{
              loc_country.select[key]
            }}</option>
          </select>
        </div>
      </div> -->

      <div class="location-row">
        <div class="left">
          <img src="../assets/images/city_logo.png" />
        </div>
        <div class="right">
          <select
            :value="loc_city.value"
            @change="valuechange('loc_city', $event.target.value)"
            ref="city_select"
            :key="city_select_update_key"
          >
            <option
              :key="'city' + index"
              v-for="(city_shortcut, index) in loc_country.data[loc_country.value]['city_data']"
              :value="city_shortcut"
              >{{ loc_city.select[city_shortcut] }}</option
            >
          </select>
        </div>
      </div>

      <div class="parameters" @click="toggle_position">
        <div class="inner left text">{{ status ? app_less_parameters_title : app_more_parameters_title }}</div>
        <div class="inner right">
          <svg v-if="status" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.255 10.28">
            <path
              style="fill: currentColor;"
              id="Strelica_Next"
              d="M1 21.3a1.854 1.854 0 0 1-.7-.2.972.972 0 0 1-.1-1.4l7.7-9-7.7-9A.966.966 0 0 1 .3.3a.972.972 0 0 1 1.4.1L10 10a1.051 1.051 0 0 1 0 1.3L1.8 21a1.135 1.135 0 0 1-.8.3z"
              class="cls-1"
              transform="rotate(-90 5.09 5.135)"
            />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.255 10.28">
            <path
              style="fill: currentColor;"
              id="Strelica_Next"
              d="M1 21.3a1.854 1.854 0 0 1-.7-.2.972.972 0 0 1-.1-1.4l7.7-9-7.7-9A.966.966 0 0 1 .3.3a.972.972 0 0 1 1.4.1L10 10a1.051 1.051 0 0 1 0 1.3L1.8 21a1.135 1.135 0 0 1-.8.3z"
              class="cls-1"
              transform="rotate(90 10.623 10.678)"
            />
          </svg>
        </div>
      </div>
      <div ref="additional" class="additional">
        <div class="location-row">
          <div class="left">
            <img src="../assets/images/wind.svg" alt="wind icon" />
          </div>
          <div class="right">
            <select :value="loc_wind.value" @change="valuechange('loc_wind', $event.target.value, true)">
              <option :key="'wind' + index" v-for="(text, index) in loc_wind.select" :value="loc_wind.data[index]">{{
                text
              }}</option>
            </select>
          </div>
        </div>
        <div class="location-row">
          <div class="left">
            <img src="../assets/images/Sun.svg" alt="sun icon" />
          </div>
          <div class="right">
            <select :value="loc_sun.value" @change="valuechange('loc_sun', $event.target.value, true)">
              <option :key="'sun' + index" v-for="(text, index) in loc_sun.select" :value="loc_sun.data[index]">{{
                text
              }}</option>
            </select>
          </div>
        </div>
        <div class="location-row last">
          <div class="left">{{ loc_internal.title }}</div>
          <div class="right">
            <select :value="loc_internal.value" @change="valuechange('loc_internal', $event.target.value, true)">
              <option value="18">18&deg;C</option>
              <option value="19">19&deg;C</option>
              <option value="20">20&deg;C</option>
              <option value="21">21&deg;C</option>
              <option value="22">22&deg;C</option>
              <option value="23">23&deg;C</option>
              <option value="24">24&deg;C</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-footer">
      <div class="inner left">{{ app_start }}</div>
      <div class="inner right" @click="routechange(1)">
        <span>
          {{ app_next }}
          <div class="arrow right">
            <img src="../assets/images/Strelica_Next.svg" alt="left" />
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  background: $lighter_background;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  .location-indent {
    flex: 1 0 1%;
    padding: 0 3.5rem;

    select {
      width: 100%;
      height: 100%;
      border-radius: 1.75rem;
      background-image: url("../assets/images/location_select_arrow.svg");
    }

    .location-title {
      font-size: 2rem;
      padding: 1.8rem 0 2.3rem 0;
      text-align: center;
      line-height: 2.6rem;
      color: $loc_back;
      font-family: "F-Dem";
      font-weight: bold;
    }

    .location-image-container {
      text-align: center;

      .location-pin {
        width: 4.2rem;
        max-width: 4.2rem;
        margin: auto;
        display: block;
      }

      .location-globus {
        margin-top: -1.6rem;
        width: 20rem;
        max-width: 20rem;
        margin-bottom: 2.2rem;
      }
    }

    .location-row {
      display: flex;
      margin-bottom: 2.2rem;
      height: 3.5rem;

      img {
        max-width: 70%;
        height: auto;
      }

      .left {
        flex: 0 0 18%;
        display: flex;
        align-items: center;
      }

      .right {
        flex: 0 0 82%;
      }

      &.last {
        margin-bottom: 4.7rem;

        .left {
          flex: 0 0 66%;
          font-size: 16px;
          line-height: 1.31;
          letter-spacing: 0.4px;
        }

        .right {
          flex: 0 0 34%;
        }
      }
    }

    .parameters {
      display: flex;
      align-items: baseline;
      justify-content: center;
      margin: 0 auto 3.6rem auto;
      font-family: F-Std;
      font-size: 1.6rem;
      line-height: 1.13;
      letter-spacing: 0.4px;
      color: $loc_back;
      width: auto;

      .inner.right {
        margin-left: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        svg {
          width: 1.4rem;
        }
      }
    }

    .additional {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
    }
  }
}

.tab-footer {
  flex: 0 0 auto;

  .inner {
    &.left {
      font-size: 1.4rem;
      color: $text_pos_light;
    }

    &.right {
      background: $loc_back;
    }
  }
}
</style>

<script>
import VueDialog from "../components/dialog";

export default {
  props: [
    "loc_wind",
    "loc_sun",
    "loc_country",
    "loc_city",
    "loc_internal",
    "loc_reference",
    "loc_ti_ref",
    "loc_hdd_ref",
    "loc_select_title",
    "loc_additional_title",
    "loc_calculation_title",
    "loc_hd",
    "loc_hdd",
    "get_loc_hdd",
    "loc_ta",
    "loc_zone",
    "app_back",
    "app_next",
    "app_start",
    "app_confirm",
    "app_proceed",
    "app_cancel",
    "app_intervention_reset",
    "get_intervention_exists",
    "app_more_parameters_title",
    "app_less_parameters_title",
  ],
  components: {
    "vue-dialog": VueDialog,
  },
  data: function () {
    return {
      active: 1,
      city_select_update_key: false,
      show_dialog: false,
      data_title: "",
      data_name: "",
      data_left: "",
      data_right: "",
      data_value: {},
      promise: null,
      status: false,
    };
  },
  methods: {
    routechange: function (index) {
      this.$emit("route_change", index);
    },
    dialogstart: async function (name, value) {
      return new Promise((res) => {
        this.promise = res;

        if ((name === "loc_country" || name === "loc_city") && this.get_intervention_exists) {
          this.data_title = this.app_intervention_reset;
          this.data_left = this.app_proceed;
          this.data_right = this.app_cancel;
          this.data_value = { name: name, value: value };
          this.data_name = name;
          this.show_dialog = true;
        } else {
          this.promise(true);
        }
      });
    },
    dialogend: function (ev) {
      if (ev.confirm) {
        this.$emit("reset_whole_intervention");
        this.promise(true);
        //this.valuechange(ev.name + "_confirmed", ev.value.value);
      } else {
        this.promise(false);
      }
      this.show_dialog = false;
    },
    valuechange: async function (name, value, isnumber) {
      if (isnumber) {
        value = +value;
      }

      if (!(await this.dialogstart(name, value))) return;

      this.$emit("value_change", {
        name: name,
        value: value,
      });

      if (name === "loc_country") {
        this.city_select_update_key = !this.city_select_update_key;
      }
    },
    split_text: function (text) {
      let index = text.indexOf(" ");
      if (index === -1) {
        return { first: "", second: text };
      }

      return { first: text.substring(0, index), second: text.substring(index + 1) };
    },
    toggle_position: function () {
      let elem = this.$refs["additional"];
      if (elem.style.maxHeight) {
        elem.style.maxHeight = null;
      } else {
        elem.style.maxHeight = elem.scrollHeight + "px";
      }
      if (this.status) {
        elem.addEventListener("transitionend", this.transitionend);
      } else {
        this.status = !this.status;
      }
    },
    transitionend: function (event) {
      this.status = !this.status;
      event.target.removeEventListener("transitionend", this.transitionend);
    },
  },
  computed: {
    hdd_strings: function () {
      let data = {};
      let { first, second } = this.split_text(this.loc_ta.title);
      data.loc_ta_1 = first;
      data.loc_ta_2 = second;
      ({ first, second } = this.split_text(this.loc_hd.title));
      data.loc_hd_1 = first;
      data.loc_hd_2 = second;
      ({ first, second } = this.split_text(this.loc_hdd.title));
      data.loc_hdd_1 = first;
      data.loc_hdd_2 = second;
      ({ first, second } = this.split_text(this.loc_hdd_ref.title));
      data.loc_hdd_ref_1 = first;
      data.loc_hdd_ref_2 = second;
      ({ first, second } = this.split_text(this.loc_ti_ref.title));
      data.loc_ti_ref_1 = first;
      data.loc_ti_ref_2 = second;
      return data;
    },
  },
};
</script>
